import { WORD_WHEEL_GRID_SIZE } from "../../../admin/pzl_wordwheel/board/wordWheelGridConstants";

export const GRID_SIZE = WORD_WHEEL_GRID_SIZE;

/** Daily Puzzle unlocks at Season Journey level 50 (matches Android). */
export const WORD_WHEEL_DAILY_UNLOCK_LEVEL = 50;

/** Prefer API `gridSize`; fall back to default when missing (legacy payloads). */
export function resolveWordWheelGridSize(puzzleOrSize) {
    if (puzzleOrSize != null && typeof puzzleOrSize === "object") {
        const n = Number(puzzleOrSize.gridSize);
        if (Number.isFinite(n) && n > 0) return n;
    } else {
        const n = Number(puzzleOrSize);
        if (Number.isFinite(n) && n > 0) return n;
    }
    return WORD_WHEEL_GRID_SIZE;
}
